/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostDownloadDebtorCollectionMutationRequest, PostDownloadDebtorCollectionMutationResponse, PostDownloadDebtorCollectionPathParams, PostDownloadDebtorCollectionQueryParams, PostDownloadDebtorCollection401, PostDownloadDebtorCollection403 } from "../../models/PostDownloadDebtorCollection";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostDownloadDebtorCollectionUrl({ debtorCode, collectionId }: { debtorCode: PostDownloadDebtorCollectionPathParams["debtorCode"]; collectionId: PostDownloadDebtorCollectionPathParams["collectionId"] }) {
  const res = { method: 'POST', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId}
 */
export async function postDownloadDebtorCollection({ debtorCode, collectionId, data, params }: { debtorCode: PostDownloadDebtorCollectionPathParams["debtorCode"]; collectionId: PostDownloadDebtorCollectionPathParams["collectionId"]; data: PostDownloadDebtorCollectionMutationRequest; params: PostDownloadDebtorCollectionQueryParams }, config: Partial<RequestConfig<PostDownloadDebtorCollectionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostDownloadDebtorCollectionMutationResponse, ResponseErrorConfig<PostDownloadDebtorCollection401 | PostDownloadDebtorCollection403>, PostDownloadDebtorCollectionMutationRequest>({ method : "POST", url : getPostDownloadDebtorCollectionUrl({ debtorCode, collectionId }).url.toString(), params, data : requestData, ... requestConfig })  
  return res.data
}